import NoSsr from "@mui/material/NoSsr";
import Popper from "@mui/material/Popper";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useItemTooltip, useMouseTracker } from "@mui/x-charts/ChartsTooltip";
import { Box } from "@mui/system";
import { generateVirtualElement } from "../../../../../../ResuableChartTooltip/generateVirtualElement";

interface Props {
  dataset: any[]; // pass the chart data here
}

export default function TooltipForShowingUploadPerc({ dataset }: Props) {
  const tooltipData: any = useItemTooltip();
  const mousePosition = useMouseTracker();

  if (!tooltipData || !mousePosition) return null;

  // identifier contains dataIndex (from your console output)
  const dataIndex = tooltipData?.identifier?.dataIndex;
  if (dataIndex == null || !dataset || !Array.isArray(dataset)) {
    return null;
  }

  // lookup the original row from the passed dataset
  const row = dataset[dataIndex] ?? null;
  // try multiple keys just in case (UploadPerc or perc_conversions_loaded)
  let uploadPerc: number | null = null;
  if (row != null) {
    if (typeof row.UploadPerc === "number") {
      const raw = row.UploadPerc;
      uploadPerc = raw > 1 ? raw : raw * 100;
    } else if (row.perc_conversions_loaded != null) {
      // if that value is 0..1 convert to percentage
      const raw = Number(row.perc_conversions_loaded);
      uploadPerc = raw > 1 ? raw : raw * 100;
    } else if (row.__raw && row.__raw.perc_conversions_loaded != null) {
      const raw = Number(row.__raw.perc_conversions_loaded);
      uploadPerc = raw > 1 ? raw : raw * 100;
    }
  }

  const isMousePointer = mousePosition?.pointerType === "mouse";
  const yOffset = isMousePointer ? 0 : 40 - (mousePosition.height ?? 0);

  return (
    <NoSsr>
      <Popper
        sx={{ pointerEvents: "none", zIndex: (theme) => theme.zIndex.modal }}
        open
        placement={isMousePointer ? "bottom" : "top"}
        anchorEl={generateVirtualElement(mousePosition)}
        modifiers={[{ name: "offset", options: { offset: [0, yOffset] } }]}
      >
        <Paper
          elevation={0}
          sx={{
            m: 1,
            p: 1.5,
            border: "solid",
            borderWidth: 0,
            borderColor: "divider",
            boxShadow: "0px 0px 3px #00000073",
            position: "relative",
            backgroundColor: "#fff",
          }}
        >
          <Stack direction="column" spacing={0.5}>
            {/* <Typography fontWeight="light" fontSize={18}>
              {formattedValue}
            </Typography> */}

            {uploadPerc != null ? (
              <Typography fontSize={12} color="text.primary">
                Upload Percentage: {uploadPerc.toFixed(1)}%
              </Typography>
            ) : (
              <Typography fontSize={12} color="text.primary">
                Upload Percentage: —
              </Typography>
            )}
          </Stack>

          <Box
            style={{
              position: "absolute",
              transform: "rotate(90deg)",
              top: "-10px",
              right: "45%",
              zIndex: "1",
              width: 0,
              height: 0,
              borderTop: "8px solid transparent",
              borderBottom: "8px solid transparent",
              borderRight: "8px solid #fff",
            }}
          />
        </Paper>
      </Popper>
    </NoSsr>
  );
}
